/* eslint-disable no-empty */

/* eslint-disable no-unused-vars */

/* eslint-disable no-useless-escape */

/*
 * @Description:
 * @Author: suzyli
 * @Date: 2020-03-27 11:21:52
 * @LastEditTime: 2020-11-25 10:37:33
 */
// ====security 前端安全相关======
import cookie from './cookie'; // cookie名:iegmilo_csrftoken

export var setCSRF = function setCSRF() {
  var sMask = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  // 设置新的cookie/token
  // 针对qq.com域名
  var count = sMask.length;
  var sToken = ''; // sToken为10位[a-zA-Z0-9]的62进制随机数

  for (var i = 0; i < 10; i++) {
    var rIndex = Math.floor(Math.random() * count); // 生成0-61的随机数

    sToken += sMask.substr(rIndex, 1);
  }

  cookie.set('iegmilo_csrftoken', sToken, '', 'qq.com', '/'); // session生效

  return sToken;
};